import { Form, Spin } from "antd";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import {
  cleanLoginUser,
  login,
  save,
  setToken,
} from "../../features/auth/authSlice";
import Header from "./Header";
import axiosInstance from "../../instance";

function LoginOtp() {
  const { loginUser, authLoading, saving } = useSelector((state) => state.auth);

  const [form] = Form.useForm();
  const formRef = useRef(null);
  const inputRefs = [useRef(null), useRef(null), useRef(null), useRef(null)];

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [formData, setFormData] = useState({});
  const [isInputEmpty, setIsInputEmpty] = useState(true);

  const [verificationCode, setVerificationCode] = useState(["", "", "", ""]);

  const [counter, setCounter] = useState({ minutes: 0, seconds: 0 });

  const cancatenatedString = verificationCode?.join("");

  const onFinish = async (data) => {
    if (isInputEmpty) {
      toast.error("Please provide a valid OTP");
      return;
    }
    const res = await dispatch(
      save({
        usrUsername: loginUser?.usrUsername,
        usrEncryptedPassword: loginUser?.usrEncryptedPassword,
        usrCode: cancatenatedString,
        url: "usr/post_authenticate_user_otp_self.action",
      })
    );
    if (res?.payload?.success) {
      await toast.success(res.payload?.messages?.message);
      await dispatch(setToken(res?.payload?.token));
      axiosInstance.defaults.headers.common["Authorization"] =
        await `${res?.payload?.token}`;
      await setIsInputEmpty(true);
      await setVerificationCode(["", "", "", ""]);
      await form.resetFields();
      await dispatch(cleanLoginUser());
      await navigate("/leave-applications-list");
    } else {
      toast.error(res.payload?.messages?.message);
    }
  };

  const handleInputChange = (e, index) => {
    const { value } = e.target;
    setIsInputEmpty(!value);
    if (value === "") {
      if (index > 0) {
        inputRefs[index - 1].current.focus();
      }
    } else if (index < inputRefs.length - 1) {
      inputRefs[index + 1].current.focus();
    }

    const updatedVerificationCode = [...verificationCode];
    updatedVerificationCode[index] = value;
    setVerificationCode(updatedVerificationCode);
  };

  const handleCancel = async () => {
    await navigate("/login");
  };
  async function handleResendOtp() {
    const res = await dispatch(login(loginUser));
    if (res?.payload?.success) {
      await toast.success(res?.payload?.messages?.message);
      await setCounter({ minutes: 0, seconds: 59 });
    } else {
      toast.error(res?.payload?.messages?.message);
    }
  }

  useEffect(() => {
    const interval = setInterval(() => {
      if (counter.minutes === 0 && counter.seconds === 0) {
        clearInterval(interval);
      } else {
        setCounter((prevCounter) => {
          if (prevCounter.seconds === 0) {
            return { minutes: prevCounter.minutes - 1, seconds: 59 };
          } else {
            return { ...prevCounter, seconds: prevCounter.seconds - 1 };
          }
        });
      }
    }, 1000);

    return () => clearInterval(interval);
  }, [counter, authLoading]);
  return (
    <>
      <div className="w-full min-h-screen flex    bg-white">
        <div className="flex flex-col w-full">
          <Header />
          <div className=" heading_1 mt-[10.5rem] justify-center items-center">
            Login
          </div>
          <div className="heading_5 mt-[1.13rem]">
            We have sent an OTP to the registered phone number
          </div>

          <Form
            layout="vertical"
            ref={formRef}
            name="control-ref"
            onFinish={onFinish}
            style={{
              maxWidth: "100%",
            }}
            className="lg:px-20 px-3"
            form={form}
          >
            <div className="flex items-center justify-center gap-[1.25rem] mt-[1.25rem]">
              {inputRefs?.map((ref, index) => (
                <div key={index}>
                  <input
                    ref={ref}
                    className="otp-input"
                    type="text"
                    maxLength="1"
                    value={verificationCode[index]}
                    onChange={(e) => handleInputChange(e, index)}
                  />
                </div>
              ))}
            </div>

            <div className="mt-[2rem] flex justify-center w-full">
              {counter.minutes === 0 && counter.seconds === 0 ? (
                <button
                  disabled={authLoading}
                  className="label_3 underline cursor-pointer"
                  onClick={handleResendOtp}
                  type="button"
                >
                {authLoading ? <Spin className="sms-spin"/> : " Resend code?"} 
                </button>
              ) : (
                <span className="label_3 !text-blu">
                  Resend in {counter.minutes.toString().padStart(2, "0")}:
                  {counter.seconds.toString().padStart(2, "0")}
                </span>
              )}
            </div>

            <div className="justify-center flex items-center gap-x-2 mt-[56px] mb-[48px]">
              <div className="w-[150px]">
                <button disabled={saving || authLoading} type="submit" className="cstm-btn">
                  {saving ? <Spin /> : "Login"}
                </button>
              </div>
            </div>
          </Form>
        </div>
      </div>
    </>
  );
}

export default LoginOtp;
